@import 'tailwindcss';

@layer base {
  :root {
    --background: 220 14% 7%;
    --foreground: 210 17% 95%;
    --muted: 215 14% 60%;
    --panel: 220 13% 12%;
    --panel-border: 220 14% 22%;
    --accent: 213 92% 58%;
    --destructive: 0 84% 60%;
  }

  html,
  body,
  #root {
    height: 100%;
    width: 100%;
    margin: 0;
    overflow: hidden;
  }

  body {
    font-family:
      -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
  }
}

@theme inline {
  --color-background: hsl(var(--background));
  --color-foreground: hsl(var(--foreground));
  --color-muted: hsl(var(--muted));
  --color-panel: hsl(var(--panel));
  --color-panel-border: hsl(var(--panel-border));
  --color-accent: hsl(var(--accent));
  --color-destructive: hsl(var(--destructive));
}
